/* @flow */
import idx from 'idx';
import * as React from 'react';
import Text from 'components/Text';
import LTISetup from 'admin/components/LTISetup';

const b = str => <Text weight="semibold">{str}</Text>;

const stepsFn = lti => {
  const url = idx(lti, _ => _.config.configUrl) || '*generate credential to generate URL*';

  return {
    steps: [
      <Text size="medium">Open Canvas in a new Browser Tab.</Text>,
      <Text size="medium">
        In Canvas, go to the {b`Admin Tab`} and select the Account that you wish to configure.
      </Text>,
      <Text size="medium">Go to the {b`Settings`} Tab.</Text>,
      <Text size="medium">Go to the {b`Apps`} Tab.</Text>,
      <Text size="medium">Click the + {b`App`} button.</Text>,
      <Text size="medium">Choose {b`By URL`} from the Configuration Type dropdown.</Text>,
      <Text size="medium">Enter ‘Remind’ in the {b`Name`} field.</Text>,
      <Text size="medium">
        Click {b`Generate Credentials`} below to generate a {b`Consumer Key`} and a{' '}
        {b`Shared Secret`}. Then go to Canvas and enter them into their respective fields
      </Text>,
      <Text size="medium">
        Enter the Config XML {url} into the {b`Config URL`} field.
      </Text>,
      <Text size="medium">Click {b`Submit`}</Text>,
    ],
    keyGeneratorStep: 8,
  };
};

class CanvasLTI extends React.Component<*, *> {
  render() {
    return (
      <LTISetup
        {...this.props}
        name="Canvas"
        stepsFn={stepsFn}
        logo={require('assets/images/canvas.svg')}
        images={[
          require('assets/images/canvas_lti_install_1.png'),
          require('assets/images/canvas_lti_install_2.png'),
        ]}
      />
    );
  }
}

export default CanvasLTI;
